module.exports = __webpack_public_path__ + "media/宇宙中最黯淡的那顆星.7e6f067d.mp3";